import {Platform, Linking} from 'react-native';

const getIosMapsUrl = (mapPosition) => {
  return `http://maps.apple.com/?daddr=${mapPosition}`;
};

const getAndroidMapsUrl = (mapPosition, mode) => {
  return `http://maps.google.com/maps?daddr=${mapPosition}`;
};

/* create google maps navigation link to open mobile navigation apps */
export const getGoogleMapsBrowserUrl = (
  mapAddress,
  latitude = null,
  longitude = null,
) => {
  var addressInfo = mapAddress;
  if (latitude && latitude !== '') {
    addressInfo = latitude + ',' + longitude;
  }
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURI(
    addressInfo,
  )}&travelmode=driving`;
};

export const startNavigation = (mapPosition) => {
  if (Platform.OS === 'android') {
    let url = getAndroidMapsUrl(mapPosition, 'd');

    Linking.canOpenURL(url).then((supported) => {
      if (supported) {
        Linking.openURL(url);
      } else {
        console.log("Don't know how to open URI: " + url);
      }
    });
  } else {
    let googleMapsAppUrl = `comgooglemaps://?daddr=${mapPosition}&directionsmode=driving`;

    // let googleMapsBrowserUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURI(
    //   mapPosition,
    // )}&travelmode=driving`;

    let appleMapsAppUrl = getIosMapsUrl(mapPosition);

    //Below code checking if google map available in the phone then its navigate to google map otherwise in ios map
    Linking.canOpenURL(googleMapsAppUrl).then((supported) => {
      if (supported) {
        Linking.openURL(googleMapsAppUrl);
      } else {
        Linking.openURL(appleMapsAppUrl);
      }
    });
  }
};
export const openUrl = (url) => {
  Linking.canOpenURL(url)
    .then((supported) => {
      if (supported) {
        Linking.openURL(url);
      } else {
        Linking.openURL(url);
      }
    })
    .catch((err) => console.log('cannot open url', err));
};
